module.exports = __webpack_public_path__ + "media/images/icons/power-standby-4b4e88794557bb66985d5a15007cc3bb.svg";